<template lang="pug">
  .c-bananas-widget(v-if='hotelLists' v-scroll="scrollVisible")
    .c-bananas-widget__loop(v-for='(hotelList, index) in hotelLists')
      .c-offercard__wrapper(v-for='(offer, index) in hotelList.data.ranks[0].items' :class="['js-offercard--' + index]")
        .c-offercard
          .c-offercard__image(:style="{backgroundImage: 'url('+ hotelList.data.properties[hotelList.data.pricings[offer].property].image.lead.urls[0].url +')'}")
          .c-offercard__info
            .c-offercard__price
              img.c-offercard__provider-image(:src="'https://s3.eu-central-1.amazonaws.com/tremo-web-assets/provider/hotels/' + hotelList.data.pricings[offer].offers[0].providers[0].name + '.png'")
              span.c-offercard__price-prefix {{ $t('text.pricefrom') }}
              span.c-offercard__price-currency(v-if="hotelList.data.pricings[offer].price.total.currency !== 'EUR'") {{$t('text.currency.' + hotelList.data.pricings[offer].price.total.currency)}}
              span.c-offercard__price-value {{ hotelList.data.pricings[offer].price.total.amount | formatPrice }}
              span.c-offercard__price-currency(v-if="hotelList.data.pricings[offer].price.total.currency === 'EUR'") {{$t('text.currency.' + hotelList.data.pricings[offer].price.total.currency)}}
            .c-offercard__category
              img.c-offercard__category-icon(src='https://s3.eu-central-1.amazonaws.com/tremo-web-assets/icons/hotels.svg')
              .c-offercard__headline
                span.c-offercard__hoteltitle {{ $t('headline.hotel.onenightat') }}
                span(v-if="hotelList.data.properties[hotelList.data.pricings[offer].property].location.city !== ''") &nbsp;{{ hotelList.data.properties[hotelList.data.pricings[offer].property].location.city }}
                span(v-else) &nbsp;{{ searchTerm }}
            strong.c-offercard__hotelname--hoteloffer {{ hotelList.data.properties[hotelList.data.pricings[offer].property].name }}
            span.c-offercard__hotelcategory
              span.c-offercard__hotel-category-point(v-for='point in hotelList.data.properties[hotelList.data.pricings[offer].property].category.value[0]')
              span.c-offercard__hotel-category-point--half(v-if='hotelList.data.properties[hotelList.data.pricings[offer].property].category[0].value[1]')
                span.c-offercard__hotel-category-point--half-left
                span.c-offercard__hotel-category-point--half-right
            p.c-offercard__hotel-location
              | {{ hotelList.data.properties[hotelList.data.pricings[offer].property].location.street }}
              | {{ hotelList.data.properties[hotelList.data.pricings[offer].property].location.zip }}
              | {{ hotelList.data.properties[hotelList.data.pricings[offer].property].location.city }},
              | {{ hotelList.data.dict.locations[hotelList.data.properties[hotelList.data.pricings[offer].property].location.country].name }}
            p.c-offercard__hotel-description {{ hotelList.data.properties[hotelList.data.pricings[offer].property].description[0].text }}
            .c-offercard__hotel-infos
              ul.c-offercard__hotel-attr-list
                li.c-offercard__hotel-attr(v-for='attr in hotelList.data.properties[hotelList.data.pricings[offer].property].facility')
                  | {{ hotelList.data.dict.facilities[attr].text }}
              .c-offercard__booking-review
                img(src='https://s3.eu-central-1.amazonaws.com/tremo-web-assets/provider/hotels/booking.svg')
                .c-offercard__booking-rating(v-if='hotelList.data.properties[hotelList.data.pricings[offer].property].rating')
                  .c-offercard__booking-rating-wording(:data-qa-rating="hotelList.data.properties[hotelList.data.pricings[offer].property].rating[0].orig") {{ hotelList.data.properties[hotelList.data.pricings[offer].property].rating[0].value }} / {{ hotelList.data.properties[hotelList.data.pricings[offer].property].rating[0].max }}
                  .c-offercard__booking-rating-count {{ hotelList.data.properties[hotelList.data.pricings[offer].property].rating[0].count }} {{ $t("text.reviews") }}
          .c-offercard__button
            form(action="https://rdr.holidaypirates.group/v1/link" target="_blank" method="post")
              input(type="hidden" name="config[redirect]" value="true")
              input(type="hidden" name="data[url][encoding]" value="base64_url")
              input(type="hidden" name="data[url][url]" :value="base64EncodeUnicode(hotelList.data.pricings[offer].offers[0].providers[0].link)")
              input.c-btn.c-btn--function.c-offercard__button-link(:value='$t("button.hotel")' type="submit" @click='clickOut')
</template>

<script>
import fecha from 'fecha'
import dbActions from '../api/dbactions'

export default {
  name: 'HotelTeaser',
  props: ['hotelLists', 'dateFormat', 'timeFormat', 'searchTerm'],
  data() {
    return {
      localMessages: this.$store.getters.getLocaleMessages,
      tracked: false,
      trackHostNames: this.$store.getters.getTrackingHostNames,
      trackingAllowed: true
    }
  },
  created() {
    this.reformatHotelData()
  },
  mounted() {
    this.scrollVisible()
  },
  filters: {
    formatDate(rawDate) {
      return fecha.format(new Date(rawDate), 'DD.MM.YYYY')
    },
    formatDescription(description) {
      if (description.length > 150) {
        return description.substring(0, 150) + ' ...'
      } else {
        return description
      }
    },
    formatPrice(price) {
      return Math.ceil(price)
    },
    filterRatingMax(maxRatingValue) {
      return maxRatingValue / 10
    }
  },
  methods: {
    clickOut() {
      // Track clickOut
      let actionData = {
        url: window.location.href,
        language: this.$store.getters.getLocale,
        type: 'clickOut',
        vertical: 'hotel',
        unique: this.$store.getters.getUniqueClickOut
      }
      this.$store.dispatch('updateUniqueClickOut')
      if (this.$store.getters.getTrackingIsAllowed) {
        dbActions.trackAction(actionData, this)
      }
      this.trackClick()
    },
    reformatHotelData() {
      let vm = this
      this.hotelLists.forEach(hotelList => {
        if (hotelList.data.hasOwnProperty('properties')) {
          for (const key of Object.keys(hotelList.data.properties)) {
            for (const keyi of Object.keys(hotelList.data.properties[key])) {
              if (keyi === 'category') {
                let newCategory =
                  hotelList.data.properties[key][keyi][0].value + ''
                newCategory = newCategory.split('.')
                let points = []
                for (let i = 0; i < parseInt(newCategory); i++) {
                  points.push('1')
                }
                if (newCategory.length > 1) {
                  newCategory = [points, true]
                } else {
                  newCategory = [points, false]
                }
                hotelList.data.properties[key][keyi].value = newCategory
              }
              if (keyi === 'rating') {
                let rating = hotelList.data.properties[key][keyi][0].value
                let ratingInWords = ''
                if (rating >= 90) {
                  ratingInWords =
                    vm.localMessages.text.hotelrating.booking.excellent + ' - '
                } else if (rating >= 80) {
                  ratingInWords =
                    vm.localMessages.text.hotelrating.booking.verygood + ' - '
                } else if (rating >= 70) {
                  ratingInWords =
                    vm.localMessages.text.hotelrating.booking.good + ' - '
                }
                hotelList.data.properties[key][keyi][0].orig =
                  hotelList.data.properties[key][keyi][0].value
                hotelList.data.properties[key][keyi][0].value =
                  ratingInWords + (rating / 10).toFixed(1)
                hotelList.data.properties[key][keyi][0].max =
                  hotelList.data.properties[key][keyi][0].max / 10
              }
            }
          }
        }
        if (hotelList.data.hasOwnProperty('pricings')) {
          // loop over pricing to get rooms count and add counter for roomtype
          for (const key of Object.keys(hotelList.data.pricings)) {
            if (hotelList.data.pricings[key].offers[0].rooms.length > 1) {
              let tempRoomTypes = []
              // if more than one rooms loop over rooms and count different roomtypes
              for (
                let i = 0;
                i <= hotelList.data.pricings[key].offers[0].rooms.length - 1;
                i++
              ) {
                let doubleType = -1
                // Check if roomtype exists in tempRoomTypes
                for (let j = 0; j <= tempRoomTypes.length - 1; j++) {
                  if (
                    tempRoomTypes[j].type ===
                    hotelList.data.rooms[
                      hotelList.data.pricings[key].offers[0].rooms[i].id
                    ].type
                  ) {
                    doubleType = j
                  }
                }
                if (doubleType !== -1) {
                  // Roomtype exists than only count roomtype up
                  tempRoomTypes[doubleType].count += 1
                } else {
                  tempRoomTypes.push({
                    id: hotelList.data.pricings[key].offers[0].rooms[i].id,
                    count: 1,
                    type:
                      hotelList.data.rooms[
                        hotelList.data.pricings[key].offers[0].rooms[i].id
                      ].type
                  })
                }
              }
              hotelList.data.pricings[key].offers[0].roomsummary = tempRoomTypes
            } else {
              // only one room, show only the roomtype without counter
              hotelList.data.pricings[key].offers[0].roomsummary = [
                {
                  count: 1,
                  type:
                    hotelList.data.rooms[
                      hotelList.data.pricings[key].offers[0].rooms[0].id
                    ].type
                }
              ]
            }
          }
        }
      })
    },
    checkTrackingAllowed() {
      // Test Cookie with tracking rules
      // this.$cookies.set('tarteaucitron', '!snowplow=false!doubleclick=true!hotjar=true!googletagmanager=true!trustpilot=true!facebook=true!instagram=true!pinterest=true!twitter=true!youtube=true')
      if (this.$cookies.isKey('tarteaucitron')) {
        let trackingAllowed = this.$cookies.get('tarteaucitron')
        trackingAllowed = trackingAllowed.split('!')
        trackingAllowed = trackingAllowed[1].split('=')
        if (trackingAllowed[1] !== 'true') {
          this.trackingAllowed = false
          // Set store flag to false for tracking is allowed
          this.$store.dispatch('updateTrackingIsAllowed')
        } else {
          if (!this.trackHostNames.includes(window.location.hostname)) {
            this.trackingAllowed = false
            // Set store flag to false for tracking is allowed
            this.$store.dispatch('updateTrackingIsAllowed')
          }
        }
      }
      // Everytime true on localhost for development
      if (window.location.hostname === 'localhost') {
        this.trackingAllowed = false
        this.$store.dispatch('updateTrackingIsAllowed')
        const urlParams = new URLSearchParams(window.location.search)
        if (urlParams.toString() !== '') {
          if (urlParams.has('bn-track')) {
            if (urlParams.get('bn-track') === '1') {
              this.trackingAllowed = true
              this.$store.dispatch('setTrackingIsAllowed')
            }
          }
        }
      }
    },
    scrollVisible() {
      if (this.trackingAllowed && !this.tracked) {
        this.checkOfferVisible()
      }
    },
    getBoundingClientRect(element) {
      const {
        top,
        right,
        bottom,
        left,
        width,
        height,
        x,
        y
      } = element.getBoundingClientRect()
      return { top, right, bottom, left, width, height, x, y }
    },
    checkOfferVisible() {
      const pageCoordinates = this.getBoundingClientRect(this.$el.children[0])
      if (
        pageCoordinates.top >= 0 &&
        pageCoordinates.left >= 0 &&
        pageCoordinates.bottom <=
          (window.innerHeight || document.documentElement.clientHeight) &&
        pageCoordinates.right <=
          (window.innerWidth || document.documentElement.clientWidth)
      ) {
        let pageType = 'undefined'
        let pagePostId = 'undefined'
        if (window.dataLayer.length > 0) {
          if (window.dataLayer[0].hasOwnProperty('pageType')) {
            pageType = window.dataLayer[0].pageType
          }
          if (window.dataLayer[0].hasOwnProperty('pagePostId')) {
            pagePostId = window.dataLayer[0].pagePostId
          }
        }
        try {
          const offer = this.hotelLists[0].data
          const offerId = offer.ranks[0].items[0]
          window.dataLayer.push({
            event: 'promoView',
            category: 'dealPromotion',
            action: 'impression',
            label:
              'automated' +
              '|' +
              pagePostId +
              '|' +
              this.hotelLists[0].config.adapter +
              '|hotel|' +
              offerId, // for example 'unifiedSearch|flight'
            value: undefined,
            ecommerce: {
              promoView: {
                promotions: [
                  {
                    id: offerId,
                    name:
                      'automated|' +
                      this.hotelLists[0].config.adapter +
                      '|' +
                      pageType +
                      '|hotel|' +
                      offer.properties[offerId].name, // for example 'unifiedSearch|flight'
                    creative:
                      offer.properties[offerId].location.continent +
                      ':' +
                      offer.properties[offerId].location.country +
                      ':' +
                      offer.properties[offerId].location.city,
                    position: undefined
                  }
                ]
              }
            }
          })
        } catch (err) {}
        this.tracked = true
      }
    },
    base64EncodeUnicode(str) {
      // First we escape the string using encodeURIComponent to get the UTF-8 encoding of the characters,
      // then we convert the percent encodings into raw bytes, and finally feed it to btoa() function.
      const utf8Bytes = encodeURIComponent(str).replace(
        /%([0-9A-F]{2})/g,
        function(match, p1) {
          return String.fromCharCode('0x' + p1)
        }
      )

      return btoa(utf8Bytes)
    },
    trackClick() {
      window.dataLayer = window.dataLayer || []
      let pageType = 'undefined'
      let pagePostId = 'undefined'
      if (window.dataLayer.length > 0) {
        if (window.dataLayer[0].hasOwnProperty('pageType')) {
          pageType = window.dataLayer[0].pageType
        }
        if (window.dataLayer[0].hasOwnProperty('pagePostId')) {
          pagePostId = window.dataLayer[0].pagePostId
        }
      }
      try {
        const offer = this.hotelLists[0].data
        const offerId = offer.ranks[0].items[0]
        window.dataLayer.push({
          event: 'promoClick',
          category: 'dealPromotion',
          action: 'conversion',
          label:
            'automated' +
            '|' +
            pagePostId +
            '|' +
            this.hotelLists[0].config.adapter +
            '|hotel|' +
            offerId, // for example 'unifiedSearch|flight'
          value: undefined,
          ecommerce: {
            promoClick: {
              promotions: [
                {
                  id: offerId,
                  name:
                    'automated|' +
                    this.hotelLists[0].config.adapter +
                    '|' +
                    pageType +
                    '|hotel|' +
                    offer.properties[offerId].name, // for example 'unifiedSearch|flight'
                  creative:
                    offer.properties[offerId].location.continent +
                    ':' +
                    offer.properties[offerId].location.country +
                    ':' +
                    offer.properties[offerId].location.city,
                  position: undefined
                }
              ]
            }
          }
        })
      } catch (err) {}
      this.tracked = true
    }
  }
}
</script>
